"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSearchPlaceholder = void 0;
var _react = require("react");
var _contexts = require("../../../contexts");
var _hooks = require("../../../hooks");
/**
 * Returns city of the first pickup point of initial location. Returns search translation as a fallback.
 */
const useSearchPlaceholder = () => {
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    pickupPoints
  } = (0, _contexts.usePickupPoints)();
  const [city, setCity] = (0, _react.useState)();
  const [cityLoaded, setCityLoaded] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (!cityLoaded && pickupPoints.length > 0) {
      const [pickupPoint] = pickupPoints;
      if (pickupPoint?.city) {
        setCity(pickupPoint.city);
      }
      setCityLoaded(true);
    }
  }, [cityLoaded, pickupPoints]);
  return (0, _react.useMemo)(() => city ?? translations.deliverySearchPickupPointsPlaceholder, [city, translations.deliverySearchPickupPointsPlaceholder]);
};
exports.useSearchPlaceholder = useSearchPlaceholder;